import { useModal } from 'modals';

import Text from '@cartwhl/ui/base/TextNew';
import Button from '@cartwhl/ui/input/Button';

import type {
  PluginConfig,
  PluginLogoComponent,
} from '../integrationsPageData';
import PluginDownloadButton from './PluginDownloadButton';

interface PluginCardProps {
  plugin: PluginConfig;
  interestLabel?: string;
  Logo: PluginLogoComponent;
}

const cardStyles = {
  available: {
    cardClassName: 'border-blue bg-blue/10',
  },
  'coming-soon': {
    cardClassName: 'border-primary bg-secondary',
  },
} as const;

export default function PluginCard({
  plugin,
  interestLabel,
  Logo,
}: PluginCardProps) {
  const { open } = useModal();
  const styles = cardStyles[plugin.status];
  const hasDownloads = (plugin.downloadOptions?.length ?? 0) > 0;

  return (
    <div
      className={`flex h-[260px] flex-col rounded-2xl border px-6 py-7 ${styles.cardClassName}`}
    >
      <div className="flex flex-col gap-6">
        <div
          className={`flex shrink-0 items-center ${plugin.logoWidthClassName}`}
          aria-label={plugin.name}
          role="img"
        >
          <Logo className="h-full w-full" />
        </div>

        <Text
          as="h2"
          token={{ base: '20/medium', lg: '24/medium' }}
          className="text-pretty"
        >
          {plugin.name}
        </Text>
      </div>

      <div aria-hidden="true" className="min-h-0 flex-1" />

      <div className="flex w-full shrink-0 pt-8">
        {plugin.status === 'available' && hasDownloads ? (
          <PluginDownloadButton options={plugin.downloadOptions!} />
        ) : (
          <Button
            variant="secondary"
            size="lg"
            className="bg-gray-30 hover:bg-gray-60 flex h-10 w-full"
            onClick={() =>
              open('NOTIFY_ME', {
                excitedAbout: plugin.excitedAbout,
                interestLabel,
              })
            }
          >
            Notify me
          </Button>
        )}
      </div>
    </div>
  );
}
